export enum InteractionTabType {
  SMS = 'sms',
  EMAIL = 'email',
  INBOUND_VOICE = 'inboundVoice',
  TWITTER = 'x',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  CHAT = 'chat',
  LINKEDIN = 'linkedin',
  COPILOTCHAT = 'copilotchat',
  VIDEOCALL = 'videocall',
  REIMBURSEMENTCLAIM = 'reimbursementclaim',
}
